import { Button, Modal, ModalDialog, FormControl, FormLabel, Input, Stack, IconButton } from "@mui/joy";
import { DataGridPremium } from "@mui/x-data-grid-premium";
import React, { useEffect, useState } from "react";
import { getFetch, postFetch } from "../../../../../../fetch/fetch";
import { dateToDateString } from "../../../etc/etcfunctions";
import { Delete } from "@mui/icons-material";

const MockExamManagement: React.FC<any> = (props) => {

    const [rows, setRows] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [update, setUpdate] = useState(0);

    const [columns, setColumns] = useState<any[]>([
        { field: "targetDate", headerName: "날짜", width: 130 },
        { field: "name", headerName: "모의고사 이름", width: 220 },
        { field: "author", headerName: "등록자", width: 100 },
        { field: "createdAt", headerName: "등록일", width: 150 },
        {
            field: "delete", headerName: "삭제", width: 100, renderCell: (params: any) => {

                const id = params.row.id;

                const deleteMockExamDay = async () => {
                    try {
                        if (!id) {
                            return;
                        }

                        if (!window.confirm("정말로 모의고사 날을 삭제하시겠습니까?")) {
                            return;
                        }

                        const result: any = await postFetch("/dashboard/salary/deletemockexamday", {
                            mockExamDayId: id,
                        });

                        if (result.message === "success") {
                            props.notify("success", "모의고사 날이 성공적으로 삭제되었습니다.");
                            setUpdate(Math.random());
                        }

                    } catch (e) {
                        console.log(e);
                    }
                };

                return (
                    <div>
                        <IconButton
                            onClick={deleteMockExamDay}
                        >
                            <Delete />
                        </IconButton>
                    </div>
                )
            }
        }
    ]);

    const [modalOpen, setModalOpen] = useState(false);

    // 모의고사 날 추가 모달의 입력값 상태
    const [newMockExamDay, setNewMockExamDay] = useState({
        date: "",
        name: "",
    });

    const [submitLoading, setSubmitLoading] = useState(false);

    useEffect(() => {

        setNewMockExamDay({
            date: "",
            name: "",
        });

    }, [modalOpen]);

    useEffect(() => {

        getMockExamDays();

    }, [update]);

    const getMockExamDays = async () => {

        try {

            setLoading(true);

            const result: any = await getFetch("/dashboard/salary/getmockexamdays");

            if (result.message === "success") {

                const newRows: any = [];

                result.data.forEach((item: any) => {
                    const oneRow: any = {};
                    oneRow.id = item.id;
                    oneRow.targetDate = item.targetDate;
                    oneRow.name = item.name;
                    oneRow.author = item.authorName;
                    oneRow.createdAt = dateToDateString(new Date(item.createdAt));
                    newRows.push(oneRow);
                });

                setRows([...newRows]);
            }

            setLoading(false);

        } catch (e) {
            console.log(e);
            setLoading(false);
        }

    }

    const handleChange = (field: "date" | "name", value: string) => {
        setNewMockExamDay((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const submitNewMockExamDay = async (e: React.FormEvent) => {
        e.preventDefault();

        try {

            if (!newMockExamDay.date || !newMockExamDay.name) {
                return;
            }

            setSubmitLoading(true);

            // 날짜는 input type="date" 값("YYYY-MM-DD")을 가공 없이 그대로 전송 (타임존 이슈 방지)
            const result: any = await postFetch("/dashboard/salary/addmockexamday", {
                targetDate: newMockExamDay.date,
                name: newMockExamDay.name,
            });

            if (result.message === "success") {
                props.notify("success", "모의고사 날이 성공적으로 추가되었습니다.");
                setModalOpen(false);
                setUpdate(Math.random());
            } else {
                props.notify("error", result.message);
            }

            setSubmitLoading(false);

        } catch (e) {
            console.log(e);
            setSubmitLoading(false);
        }
    };

    return (
        <div>
            <div style={{
                marginTop: "30px",
                marginBottom: "15px",
                width: "800px",
                display: "flex",
                justifyContent: "flex-end",
            }}>
                <Button
                    variant="outlined"
                    onClick={() => setModalOpen(true)}
                >
                    모의고사 날 추가
                </Button>
            </div>
            <div
                style={{
                    height: "600px",
                    width: "800px",
                }}
            >
                <DataGridPremium
                    rows={rows}
                    columns={columns}
                    loading={loading}
                    density="compact"
                    hideFooter={true}
                />
            </div>

            {/* 모의고사 날 추가 모달 */}
            <Modal
                open={modalOpen}
                onClose={() => setModalOpen(false)}
            >
                <ModalDialog>
                    <form onSubmit={submitNewMockExamDay}>
                        <Stack spacing={2}>
                            <div style={{ fontSize: "18px", fontWeight: 600 }}>
                                모의고사 날 추가하기
                            </div>

                            <FormControl>
                                <FormLabel>날짜</FormLabel>
                                <Input
                                    type="date"
                                    value={newMockExamDay.date}
                                    onChange={(e) =>
                                        handleChange("date", e.target.value)
                                    }
                                    required
                                />
                            </FormControl>

                            <FormControl>
                                <FormLabel>모의고사 이름</FormLabel>
                                <Input
                                    placeholder="모의고사 이름을 입력하세요"
                                    value={newMockExamDay.name}
                                    onChange={(e) =>
                                        handleChange("name", e.target.value)
                                    }
                                    required
                                />
                            </FormControl>

                            <Stack direction="row" spacing={1} justifyContent="flex-end">
                                <Button
                                    variant="outlined"
                                    type="button"
                                    onClick={() => setModalOpen(false)}
                                >
                                    취소
                                </Button>
                                <Button type="submit"
                                    loading={submitLoading}
                                    disabled={
                                        submitLoading
                                        || !newMockExamDay.date
                                        || !newMockExamDay.name
                                    }
                                >
                                    전송
                                </Button>
                            </Stack>
                        </Stack>
                    </form>
                </ModalDialog>
            </Modal>
        </div>
    );
};

export default MockExamManagement;
